require.register("modules/m04/m04-activity/page-15-co/page-15-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page15co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page15co;

  
});

